var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import MuiStepper from '@mui/material/Stepper';
/**
 * Special className for the progress variant Stepper - used to conditionally apply variant styles
 */
export const progressVariantStepperClassName = 'progressStepper';
/**
 * Stepper component that extends MUI Stepper and adds a 'progress' variant.
 * This variant has a different style to indicate progress rather than info.
 *
 * See Storybook for examples.
 */
export const ProgressStepper = (_a) => {
    var { children, variant = 'default' } = _a, props = __rest(_a, ["children", "variant"]);
    return (React.createElement(MuiStepper, Object.assign({}, props, { classes: Object.assign({ 
            // Sets special className for the progress variant on the Stepper root element
            root: variant === 'progress' ? progressVariantStepperClassName : undefined }, props.classes) }), children));
};
